/* alignment.js – UI controller, 4 KB */

export default function initAlignmentSolver(section) {
  // DOM refs
  const form = section.querySelector("form");
  const table = section.querySelector("table tbody");
  const status = section.querySelector("[data-status]");

  const jsonUrl = section.dataset.json;
  const workerUrl = section.dataset.worker;

  const worker = new Worker(workerUrl, { type: "module" });

  worker.addEventListener("message", ({ data }) => {
    if (data.error) return (status.textContent = data.error);
    renderTable(data.solutions);
    status.textContent = `${data.solutions.length} passende Konfigurationen`;
  });

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    status.textContent = "⏳ Berechne …";

    const formData = new FormData(form);
    const current = ["urear", "lfront", "tie", "spring"].map((f) =>
      parseFloat(formData.get(f))
    );
    const aim = ["camber", "toe"].map((f) => parseFloat(formData.get(f)));
    const tol = ["tolcamber", "toltoe"].map((f) => parseFloat(formData.get(f)));

    worker.postMessage({
      opts: {
        current,
        defaultL: [272, 330, 380, 197],
        aim,
        tolerance: tol,
        jsonUrl,
      },
    });
  });

  function renderTable(rows) {
    table.innerHTML = rows
      .map(
        (r) => `
      <tr>
        <td>${r.dURear}</td><td>${r.dLFront}</td><td>${r.dTie}</td>
        <td>${r.dCamber.toFixed(3)}°</td><td>${r.dToe.toFixed(3)}°</td>
        <td>${r.dBump.toFixed(3)} mm/m</td><td>${r.shimSum}</td>
      </tr>`
      )
      .join("");
  }
}
